import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/shared/api';
import { propertyKeys } from '@/features/properties/queries';

/** Kompakte {id,name}-Liste aller Properties für die Zuweisungs-Picker (C3). */
export interface AssignableProperty {
  id: string;
  name: string;
}

// Zuweisungs-Picker brauchen die volle Property-Liste, nicht paginiert.
const ALL = { page: 1, pageSize: 200 } as const;

export function useAssignableProperties(enabled = true) {
  const api = useApi();
  return useQuery({
    queryKey: propertyKeys.list(ALL),
    queryFn: () => api.properties.list(ALL),
    enabled,
    select: (data): AssignableProperty[] =>
      data.items.map((p) => ({ id: p.id, name: p.adminDisplayName ?? p.name })),
  });
}
